import axios from 'axios';
import moment from 'moment';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'DimValCode','tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/jurnal${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    getcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`coa/getcoa/${obj.tahun}`);
                // console.log(`coa/getcoa/${obj.tahun}`, data);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    kodejurnal() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/buku/kodejurnal");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nomor','no_jurnal', 'tanggal', 'kodejurnal'];
                let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                    }
                const { data } = await axios.get(`jurnal/detail/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detailayat(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nomor','no_jurnal', 'tanggal', 'kodejurnal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`jurnal/detailayat/${str}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    downloadtemplate() {
        axios({
            url: `/download/jv-upload`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'EkosSystem-JV-upload-template.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },    
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("jurnal", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    savebuku(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("buku", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['nomor','no_jurnal', 'tanggal', 'kodejurnal'];
                let str = '';
                    for (const key in obj) {
                        if (keys.indexOf(key) >= 0 && obj[key]) {
                            str += str ? '&' : '?';
                            str += key + '=' + encodeURIComponent(obj[key]);
                        }
                }
                const { data } = await axios.delete(`jurnal${str}`);

                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.put(`jurnal/posting`, obj);
                resolve(data);
            } catch (error) {
                console.log('posting error : ',error);
                errorHandler(error, reject)
            }
        });
    },
    postingselected(obj) {
        return new Promise(async (resolve, reject) => {
            console.log('obj',obj);
            try {
                const { data } = await axios.put(`jurnal/postingselected`, obj);
                resolve(data);
            } catch (error) {
                console.log('posting error : ',error);
                errorHandler(error, reject)
            }
        });
    },
    postingall(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                let playload={};
                const keys = ['uraian', 'DimCol', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
                for (const key in obj) {

                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        playload[key] = obj[key];
                    }
                }
                const { data } = await axios.put(`jurnal/postingall`, playload);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url ;
            let str = '';
            try {
                switch (obj.fsubkode2) {
                    case 'arinvtt':
                        str = '?key=' + encodeURIComponent(obj.subkode2);
                        url = `/arinv/printjv`;
                        break;

                    case 'tranbank':
                        str ='?key=' + encodeURIComponent(obj.subkode2);
                        if (obj.nomor.substr(1, 1) == 'M'){
                            url = `/tranbank/printreceivejv`;

                        } else {
                            url = `/tranbank/printpaymentjv`;
                        }
                        break;

                    default:
                        // // str = `?nomor=${encodeURIComponent(obj.no_jurnal)}&tanggal=${encodeURIComponent(moment(obj.tanggal).format('YYYY-MM-DD'))}`;
                        const keys = ['nomor','no_jurnal', 'tanggal', 'kodejurnal'];
                        str = '';
                        for (const key in obj) {
                            if (keys.indexOf(key) >= 0 && obj[key]) {
                                str += str ? '&' : '?';
                                str += key + '=' + encodeURIComponent(obj[key]);
                            }
                        }
                        url = `/jurnal/printjv`;
                        break;
                }

                url += str;
                const { data } = await axios.get(url);

                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    exportxls(obj = {}) {
        // return new Promise(async (resolve, reject) => {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/jurnal/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'list_jurnal.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    upload(fileXlsx) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', fileXlsx, fileXlsx.name);
                const resp = await axios.post("jurnal/uploadjv", fd);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};